import { useState } from "react";
import { Col, Input, InputGroup, Row } from "reactstrap";
import { Btn, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { Send } from "../../../../utils/Constant";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { replyByUserAsync, sendMessageAsync } from "../../../../ReduxToolkit/Reducers/ChatSlice";
import EmojiPicker from "emoji-picker-react";

const SendChat = () => {
  const [messageInput, setMessageInput] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const { chats, selectedUser, currentUser } = useAppSelector((state) => state.chatData);

  const dispatch = useAppDispatch();
  const addEmoji = (emoji: string) => {
    const text = `${messageInput}${emoji}`;
    setShowEmojiPicker(false);
    setMessageInput(text);
  };
  const handleMessageChange = (message: string) => {
    setMessageInput(message);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleMessagePress();
    }
  };

  const handleMessagePress = () => {
    var container = document.getElementsByClassName("chat-history")[0];
    setTimeout(function () {
      container?.scrollBy({ top: 200, behavior: "smooth" });
    }, 310);
    let currentUserId = currentUser.id;
    let selectedUserId = selectedUser.id;
    let selectedUserName = selectedUser.name;
    if (messageInput.length > 0) {
      dispatch(sendMessageAsync({ currentUserId, selectedUserId, messageInput, chats }));
      setMessageInput("");
      setTimeout(() => {
        const replyMessage = "Hey This is " + selectedUserName + ", Sorry I'm busy right now, I will text you later";
        if (selectedUser.online === true) {
          document.getElementsByClassName("status-circle")[0]?.classList.add("online");
        }
        dispatch(replyByUserAsync({ currentUserId, selectedUserId, replyMessage, chats }));
      }, 2000);
    }
  };
  return (
    <div className="chat-message clearfix">
      <Row>
        <div>{showEmojiPicker ? <EmojiPicker onEmojiClick={(e) => addEmoji(e.emoji)} /> : null}</div>
        <Col xl="12" className="d-flex">
          <div className="smiley-box bg-primary">
            <div className="picker" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
              <Image src={dynamicImage("smiley.png")} alt="smiley" />
            </div>
          </div>
          <InputGroup className="text-box">
            <Input type="text" className="input-txt-bx" placeholder="Type a message......" value={messageInput} onChange={(e) => handleMessageChange(e.target.value)} onKeyPress={handleKeyPress} />
            <Btn className="input-group-text" color="primary" onClick={handleMessagePress}>
              {Send}
            </Btn>
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

export default SendChat;
